module.exports = __webpack_public_path__ + "img/img (52).08b3cfb2.jpg";